import React from 'react';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Planning our parish pilgrimage felt overwhelming until we connected with Premier. They understood our spiritual focus and helped us create an itinerary that was meaningful for all ages. The support throughout was exceptional.',
    author: 'Fr. Michael Chen',
    role: "St. Mary's Parish",
    type: 'Faith Leader'
  }, {
    quote: 'Our reunion trip to Ireland was a huge success. Premier made it easy to coordinate 35 classmates, and their payment timeline took the stress out of collecting deposits. Everyone had an amazing time.',
    author: 'Sarah Williams',
    role: "Class of '89 Reunion Committee",
    type: 'Alumni Organizer'
  }, {
    quote: "I've organized three trips with Premier for our senior center. They're patient, detail-oriented, and really understand the needs of older travelers. Our members always come back asking when the next trip is!",
    author: 'Linda Martinez',
    role: 'Riverside Senior Center',
    type: 'Activity Director'
  }];
  return <section className="py-20 bg-neutral-50" data-id="element-212">
      <div className="container mx-auto px-4" data-id="element-213">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary text-center mb-16" data-id="element-214">
          What organizers say
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-215">
          {testimonials.map((item, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative" data-id="element-216">
              <Quote className="absolute top-6 left-6 text-gold/20 w-12 h-12" data-id="element-217" />
              <div className="relative z-10" data-id="element-218">
                <p className="text-gray-600 italic mb-6 pt-4 leading-relaxed" data-id="element-219">
                  "{item.quote}"
                </p>
                <div data-id="element-220">
                  <p className="font-bold text-primary" data-id="element-221">{item.author}</p>
                  <p className="text-sm text-teal font-medium" data-id="element-222">{item.role}</p>
                  <p className="text-xs text-gray-400 mt-1 uppercase tracking-wider" data-id="element-223">
                    {item.type}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}